import { useMemo } from 'react';
import { useOgConsolidationUserState } from '@atlassian/jira-eoc-changeboarding/src/controllers/use-og-consolidation-user-state/index.tsx';
import { shouldRenderBenefitModal } from '@atlassian/jira-eoc-changeboarding/src/ui/benefit-modal/utils.tsx';
import { useOgTenantInfo } from '@atlassian/jira-eoc-tenant-info/src/controllers/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { BANNER_NAME, HEIGHT } from '../common/constants.tsx';

export const useBannerEocTransition = () => {
	const { data, error } = useOgConsolidationUserState();
	const isAdmin = useIsAdmin();
	const isSiteAdmin = useIsSiteAdmin();
	const { isTransitionEligible, error: tenantInfoError } = useOgTenantInfo();

	const isEnabled = Boolean(
		(isAdmin || isSiteAdmin) &&
			// Tenant info
			!tenantInfoError &&
			isTransitionEligible &&
			// User state
			!error &&
			data &&
			(!data.isTransitionBannerDismissed ||
				shouldRenderBenefitModal({
					bannerDismissedAt: data.transitionBannerDismissedAt,
					isDismissed: data.isBenefitModalDismissed,
				})),
	);

	return useMemo(
		() => ({
			isEnabled,
			name: BANNER_NAME,
			height:
				data && shouldRenderBenefitModal({ bannerDismissedAt: data.transitionBannerDismissedAt })
					? 0
					: HEIGHT,
		}),
		[data, isEnabled],
	);
};
